import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '@perval/shared';
import { Subject } from 'rxjs';
import { ModalService } from '../p-modal/p-modal.service';

enum FooterModalId {
  CGU_MODAL = 'CGU_MODAL',
  PPD_MODAL = 'PPD_MODAL',
}

@Component({
  selector: 'p-footer',
  templateUrl: './p-footer.component.html',
  styleUrls: ['./p-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PFooterComponent implements OnInit, OnDestroy {
  @Input() isCguDisplayed = false;
  @Input() isDpoDisplayed = false;

  footerModalId = FooterModalId;
  isModalCguOpen = false;
  isModalPpdOpen = false;

  cguUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
    `${environment.host}/system/files/cgu_perval_-_dpo_20210722_-_20210803_dpo-politique_protection_des_donn.pdf#toolbar=0&navpanes=0&scrollbar=0`,
  );

  ppdUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
    `${environment.host}/system/files/dpo-politique_protection_des_donnees_et_gestion_des_cookies_v1.9_-_perva.pdf#toolbar=0&navpanes=0&scrollbar=0`,
  );

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly modalService: ModalService,
    private readonly sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.modalService.getModalState().subscribe((modalId) => {
      this.isModalCguOpen = modalId === FooterModalId.CGU_MODAL;
      this.isModalPpdOpen = modalId === FooterModalId.PPD_MODAL;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get currentYear(): string {
    return new Date().getFullYear().toString();
  }

  openModal(modalId: FooterModalId) {
    this.modalService.showModal(modalId);
  }
}
